import { Autocomplete, TextField } from '@mui/material';
import ArrowDown from '@mui/icons-material/KeyboardArrowDownRounded';

import * as S from './styles';

export const CustomAutoComplete = ({
  width,
  height,
  fullWidth = false,
  loading = false,
  disabled = false,
  options,
  renderInput,
  onChange,
  onInputChange,
  label,
  popupIcon,
  sx,
  maxWidth,
  ...restProps
}: any) => {
  const defaultInput = (params: any) => <TextField {...params} label={label} variant="standard" />;

  return (
    <S.Container width={width} height={height} fullWidth={fullWidth} $maxWidth={maxWidth}>
      <Autocomplete
        options={options}
        renderInput={renderInput || defaultInput}
        onChange={onChange}
        disabled={disabled}
        fullWidth={fullWidth}
        onInputChange={onInputChange}
        popupIcon={popupIcon || <ArrowDown />}
        sx={sx}
        isOptionEqualToValue={(option: { label: string; value: string }, value) => option.value === value.value}
        {...restProps}
      />
      {loading && <S.LoadingIcon />}
    </S.Container>
  );
};
